<ng-container *ngIf="!item.hidden">
  <span class="navigation-section-text">{{ item.translate ? (item.translate | translate) : item.title }}</span>
  <!-- More icon in collapsed menu -->
  <span [data-feather]="'more-horizontal'"></span>
</ng-container>
